<template>
  <div id="main-container">
    <main>
      <RouterView />
    </main>

    <div v-if="ui.isUpdatingApp" class="app-update-overlay">
      <div class="app-update-card">
        <h2 class="app-update-title">Updating your games…</h2>
        <p class="app-update-message">
          {{
            ui.updateMessage ||
            "We're getting the latest version ready for you."
          }}
        </p>
        <Timer :hide-label="true" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import { Capacitor } from '@capacitor/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { onMounted } from 'vue';
import { useUIStore } from '@/stores/uiStore';
import Timer from '@/components/GamePlay/Common/Timer.vue';

const ui = useUIStore();

onMounted(async () => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  try {
    await ScreenOrientation.lock({ orientation: 'landscape' });
  } catch (error) {
    if (import.meta.env.DEV) {
      console.warn('[orientation] Failed to lock orientation:', error);
    }
  }
});
</script>

<style scoped>
.app-update-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.app-update-card {
  background: #ffffff;
  color: #222222;
  border-radius: 16px;
  padding: 24px 32px;
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
}

.app-update-title {
  font-size: 1.4rem;
  margin-bottom: 0.5rem;
}

.app-update-message {
  font-size: 1rem;
  margin-bottom: 1.25rem;
}

/* Reuse the existing timer bar as a friendly progress animation */
.play_timer {
  margin-top: 0.5rem;
}
</style>
